import * as PIXI from "pixi";
import { ColorMatrixFilter } from "@pixi/filter-color-matrix";

export function animatePixiFilter(
  displayObject: PIXI.DisplayObject,
  filter: ColorMatrixFilter,
  active: boolean,
  steps: number = 2,
  fps: number = 30
) {
  const interval = 1000 / fps;
  const step = 1 / steps;

  if (!displayObject.filters) displayObject.filters = [];
  const index = displayObject.filters.indexOf(filter);
  if (index === -1) displayObject.filters.push(filter);

  let i = 0;
  const id = setInterval(() => {
    if (active) {
      filter.alpha += step;
    } else {
      filter.alpha -= step;
    }
    if (++i >= steps) {
      clearInterval(id);
      if (!active) {
        console.log("remove filter");
        const index = displayObject.filters!.indexOf(filter);
        displayObject.filters!.splice(index, 1);
      } else {
        filter.alpha = 1;
      }
    }
  }, interval);
}

export function convertToDisplayObjectToSprite(
  displayObject: PIXI.DisplayObject,
  renderer: PIXI.Renderer
): () => PIXI.Sprite {
  const bounds = displayObject.getBounds();
  const renderTexture = PIXI.RenderTexture.create({
    width: bounds.width,
    height: bounds.height,
  });
  console.log("bounds", bounds);
  renderer.render(displayObject, { renderTexture });

  return () => {
    const sprite = new PIXI.Sprite(renderTexture);
    sprite.x = bounds.x;
    sprite.y = bounds.y;
    return sprite;
  };
}
